import React from 'react';
import Image from 'next/image';

const HeaderBackgroundBanner = () => {
  return (
    <>
      <div
        className="banner d-none d-lg-block"
        style={{
          position: 'absolute',
          top: '0',
          height: '135px',
          overflow: 'hidden',
        }}
      >
        <div className="im-slider">
          <Image
            src="/image/arac-satis.png"
            width="1440"
            height="250"
            objectFit="cover"
            layout="responsive"
          />
        </div>
      </div>
      <div className="banner d-lg-none">
        <div className="im-slider">
          <Image
            src="/image/arac-satis.png"
            width="1440"
            height="500"
            objectFit="cover"
            layout="responsive"
          />
        </div>
      </div>
    </>
  );
};

export default HeaderBackgroundBanner;
